import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import {
    BreadCrumbs,
    Table,
    Column,
    PageTitleWithToolTip,
} from '../../Common';
import Routes from '../../../routes';
import { trakrefFontFamily } from '../../../utils';
import { Grid, Chip, Badge } from '@mui/material';
import useNavigate from '../../../hooks/useNavigate';
import EditIcon from '@mui/icons-material/Edit';
import EditInstanceSSO from './EditInstanceSSO';

const toolTipText = `
    Configure SSO settings for Trakref accounts on both desktop and mobile.
`;

const manageServiceProvidersText = "Configure SSO";

const ConfigureSSO = () => {
    const [filterOptions, setFilterOptions] = useState([
        { property: "enabledOnDesktop", value: "true", name: "Yes" },
        { property: "enabledOnDesktop", value: "false", name: "No" },
        { property: "enabledOnMobile", value: "true", name: "Yes" },
        { property: "enabledOnMobile", value: "false", name: "No" },
    ]);

    const commonChipStyle = { fontFamily: trakrefFontFamily, fontWeight: 600 };
    const chipIconStyle = { marginLeft: "15px", marginRight: 0 };

    const navigate = useNavigate({ pageName: 'ConfigureSSO' });
    const [modalData, setModalData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [refresh, setRefresh] = useState(false);

    function handleEdit(data) {
        setModalData(data);
        setModalOpen(true);
    }
    
    const renderBadge = (chipTextAndBadgeColor) => (
        <Badge
            variant="dot"
            sx={{
                "&.MuiChip-icon": { ...chipIconStyle },
                "& .MuiBadge-badge": {
                    backgroundColor: chipTextAndBadgeColor,
                    color: chipTextAndBadgeColor,
                }
            }}
        />
    );

    const determineChipStyle = (fieldIsTrue) => {
        if (fieldIsTrue) {
            return {
                chipColor: "#DDFFCD",
                chipTextAndBadgeColor: "#007F00"
            };
        }

        return {
            chipColor: "#FFE6C0",
            chipTextAndBadgeColor: "#F99500"
        };
    };

    
    return (
        <>
            <BreadCrumbs
                path={[
                    { text: "Geek Command Center", to: "/GeekCommandCenter" },
                    { text: manageServiceProvidersText }
                ]}
            />

            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <PageTitleWithToolTip
                        pageTitle={manageServiceProvidersText}
                        toolTipText={toolTipText}
                    />
                </Grid>
                <Grid item xs={12} >
                    <Table
                        renderDefaultFilter
                        customizeColumnVisible={false}
                        filterOptions={filterOptions}
                        url={Routes.InstanceSSO.InstanceSSOTable()}
                        noResultText="Oops...It is empty here..."
                        refresh={refresh}
                        rowActions={[
                            {
                                icon: (_) => EditIcon,
                                toolTip: "Edit",
                                onClick: row => handleEdit(row),
                                isVisible: (_) => true
                            },
                        ]}
                    >
                        <Column id='account_name' title="Account Name" property="accountName" filter="text" />
                        <Column id='redirect_URL' title="RedirectURL" property="redirectURL" filter="text" />
                        <Column
                            id='enabled_on_desktop'
                            title="Enabled On Desktop"
                            property="enabledOnDesktop"
                            filter="dropdown"
                           
                            render={({ enabledOnDesktop }) => {
                                const { chipColor, chipTextAndBadgeColor } = determineChipStyle(enabledOnDesktop);
                                return (
                                    <Chip
                                        icon={renderBadge(chipTextAndBadgeColor)}
                                        label={enabledOnDesktop ? "Enabled On Desktop" : "Disabled On Desktop"}
                                        sx={{
                                            bgcolor: chipColor,
                                            color: chipTextAndBadgeColor,
                                            ...commonChipStyle
                                        }}
                                    />
                                );
                            }}
                        />
                        <Column
                            id='enabled_on_mobile'
                            title="Enabled On Mobile"
                            property="enabledOnMobile"
                            filter="dropdown"
                            render={({ enabledOnMobile }) => {
                                const { chipColor, chipTextAndBadgeColor } = determineChipStyle(enabledOnMobile);
                                return (
                                    <Chip
                                        icon={renderBadge(chipTextAndBadgeColor)}
                                        label={enabledOnMobile ? "Enabled On Mobile" : "Disabled On Mobile"}
                                        sx={{
                                            bgcolor: chipColor,
                                            color: chipTextAndBadgeColor,
                                            ...commonChipStyle
                                        }}
                                    />
                                );
                            }}
                        />
                        <Column id='configuration_Details' title="Configuration Details" property="configurationDetails" filter="text" />
                    </Table>
                </Grid>
            </Grid>

            <EditInstanceSSO
                payload={modalData}
                modalOpen={modalOpen}
                onClose={() => { setModalOpen(false); setRefresh(!refresh); }}
            />

        </>
    );
};

export default ConfigureSSO;
